import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";
import apiRequestType from "../../apiRequestType";

const postRoleMenuMapping = (data) => {
  return apiRequestType(
    apiTypes.POST,
    apiConstants.ADMIN.ROLES_AND_PERMISSION.POST_ROLE_MENU_MAPPING,
    data
  );
};

export default postRoleMenuMapping;
